import { render } from "./EnvironmentTag.vue?vue&type=template&id=f9bc601a&scoped=true"
import script from "./EnvironmentTag.vue?vue&type=script&lang=js"
export * from "./EnvironmentTag.vue?vue&type=script&lang=js"

import "./EnvironmentTag.vue?vue&type=style&index=0&id=f9bc601a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9bc601a"]])

export default __exports__